module.exports = __webpack_public_path__ + "img/20.2eae5ead.svg";